import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { config } from "./app.config";

const initializeI18next = (settings: any) => {
  i18next.use(initReactI18next).init({
    fallbackLng: "en",
    resources: {
      en: {
        translation: {
          ApiEndpointThatReturnsJsonArray: "An API endpoint which returns a json key value array",
          account: "Account",
          analytics: "Analytics",
          gaMeasurementId: "GA Measurement ID",
          blocked: "Blocked",
          blockedMessage: `Your account has been blocked. If you have any questions about this, please contact ${settings?.global_wording?.app_name}.`,
          accountBlocked: "Account Blocked",
          active: "Active",
          addAnotherSponsor: "Add another sponsor",
          audio: "Audio",
          admin: "Admin",
          brand: "brand",
          sponsors: "sponsors",
          globalWording: "global wording",
          emails: "emails",
          memberZone: `${settings?.global_wording?.entity_members} Zone`,
          adminAreaHeaderLogo: "Admin Area Header Logo",
          loginScreenLogo: "Login Screen Logo",
          appHeaderLogo: "App Header Logo",
          adminProfileMenuSegmentManage: "Manage Account",
          adminProfileMenuSegmentNotes: "Notes",
          adminProfileMenuSegmentOverview: "Overview",
          adminProfileMenuSegmentRegistration: `${settings?.global_wording?.section_registration} Progress`,
          adminProfileMenuSegmentRequest: "Requests",
          andOthers: "And others",
          application: "Application",
          approve: "Approve",
          approved: "Approved",
          approving: "Approving",
          articles: "Articles",
          at: "at",
          instance: settings?.global_wording?.app_name,
          attributes: "Atrribtues",
          back: "Back",
          bankDetails: "Bank Details",
          banking: "Banking",
          block: "Block",
          blockAccountConfirmHeading: `Block ${settings?.global_wording?.entity_members} account`,
          blockAccountConfirmText: "Are you sure you want to block this account?",
          cancel: "Cancel",
          cancelAccountButtonText: `Cancel ${settings?.global_wording?.entity_members} account`,
          cancelAccountConfirmButtonText: "Cancel account",
          cancelAccountConfirmText: "Are you sure you want to cancel this account?",
          cancelAccountErrorText: `Unable to cancel ${settings?.global_wording?.entity_members} account`,
          cancelAccountSuccessText: `${settings?.global_wording?.entity_members} account cancelled`,
          cancelMembership: "Cancel Membership",
          cancelMembershipConfirmationTextOne: "By using this option you will be cancelling your Membership.",
          cancelMembershipConfirmationTextTwo: "We highly recommend that you contact us before cancelling so we understand your concerns.",
          cancelMembershipError: "There was an error cancelling your membership.",
          cancelled: "Cancelled",
          category: "Category",
          changePassword: "Change Password",
          changeRejected: "Change Rejected",
          changeRequested: "Change Requested",
          changeRequestedError: `There was an error updating your ${settings?.global_wording?.misc_profile.toLowerCase()}. Please try again later.`,
          changeRequestedMemberConfirmation: `Your update has been received and will be visible on your ${settings?.global_wording?.misc_profile.toLowerCase()} in a couple of minutes.`,
          channelImage: `${settings?.global_wording?.misc_channel} ${settings?.global_wording?.misc_picture}`,
          channelInfo: `${settings?.global_wording?.misc_channel} Info`,
          channelName: `${settings?.global_wording?.misc_channel} Name`,
          chat: settings?.global_wording?.section_chat,
          chats: settings?.global_wording?.section_chat + "s",
          chatWith: "New " + settings?.global_wording?.section_chat,
          chatWithUs: settings?.global_wording?.section_chat + " With Us",
          checkbox: "Checkbox",
          close: "Close",
          completed: "Completed",
          confirmNewPassword: "Confirm New Password",
          contact: "Contact",
          contactUs: "Contact us",
          contactUsText: "Select an option below to get in touch with us. Your enquiry will be routed towards the person who can help you best.",
          contactUsSelectedCategoryText:
            "You have selected %CATEGORY%. Now fill out the form below to get in touch with us and your query will be sent via the chat to the person who can help you best.",
          country: "Country",
          createChannel: `Create ${settings?.global_wording?.misc_channel}`,
          currentPassword: "Current password",
          date: "Date",
          dateOfPublication: "Date of Publication",
          deactivated: "Deactivated",
          deactivating: "Deactivating",
          declined: "Declined",
          delete: "Delete",
          deleteAccountConfirmButtonText: "Delete all data",
          deleteAccountConfirmText: "Are you sure you want to delete all data for this account?",
          deleteAccountErrorText: `Unable to delete all ${settings?.global_wording?.entity_members.toLowerCase()} data`,
          deleteAllAccountData: "Delete All Account Data",
          deleteArticleConfirmation: "Are you sure you want to delete this article?",
          deleteQuestionConfirmation: "Are you sure you want to delete this question?",
          description: "Description",
          details: "Details",
          doesNotRequire: "does not require",
          dontHaveAccount: "No account yet?",
          edit: "Edit",
          editArticle: "Edit Article",
          editChannel: `Edit ${settings?.global_wording?.misc_channel}`,
          editProfileExplaination: `This is your ${settings?.global_wording?.app_name} ${settings?.global_wording?.misc_profile.toLowerCase()}. Come here any time to update your details.`,
          editProfilePictures: `Edit ${settings?.global_wording?.misc_profile.toLowerCase()} ${settings?.global_wording?.misc_picture}s`,
          email: "Email",
          enabled: "Enabled",
          enterEmailAddress: "Please enter your email address.",
          errorOpeningChat: `Error opening chat with ${settings?.global_wording?.entity_members.toLowerCase()}.`,
          female: "Female",
          fieldDisplayName: "Field display name",
          fields: "fields",
          field: "Field",
          file: "File",
          filter: "Filter",
          filterUsersError: `There was an error filtering the ${settings?.global_wording?.entity_members.toLowerCase()}s.`,
          forMoreInformation: "for more information",
          forgottenPassword: "Forgotten password?",
          form: "Form",
          formHandler: "Form Handler",
          formHasBeenUpdated: "form has been updated",
          forms: "Forms",
          funFacts: "Fun Facts",
          gif: "GIF",
          gettingUserError: `There was an error retrieving this ${settings?.global_wording?.entity_members.toLowerCase()}.`,
          givenDataInvalid: "The given data was invalid.",
          hasBeenDeleted: "has been deleted",
          history: "History",
          image: settings?.global_wording?.misc_picture,
          imageInputExplainationText: `Please only provide ${settings?.global_wording?.misc_picture.toLowerCase()}s that you are sure you have the legal right to grant ${settings?.global_wording?.app_name} permission to use for commercial purposes.`,
          inRankings: "In Rankings",
          inputElementName: "Input element name",
          invite: "Invite",
          inviteUsers: `Invite ${settings?.global_wording?.entity_members}s`,
          isNow: "is now",
          jsonObjectOfKeyValuePairs: "A json object of key value pairs",
          key: "key",
          label: "Label",
          laravelValidationRules: "Laravel Validation Rules",
          lastActive: "Active",
          latest: settings?.global_wording?.section_latest,
          latestArticles: "Latest Articles",
          leave: "Leave",
          leaveChat: "Leave Chat",
          loadingMembers: `Loading ${settings?.global_wording?.entity_members.toLowerCase()}s`,
          resetColours: "Reset Colours",
          resetGradients: "Reset Gradients",
          leaveChatConfirmation: "Are you sure you want to leave this chat?",
          legal: "Legal",
          loading: "Loading",
          emailVariables: "Email Variables",
          clearAll: "Clear All",
          loadingUsersError: `Something went wrong while loading the ${settings?.global_wording?.entity_members.toLowerCase()}s.`,
          logOut: "Log out",
          loggedInAs: "You're logged in as",
          loggingYouIn: "Logging you in",
          male: "Male",
          emailSignature: "Email Signature",
          manageAccount: "Manage Account",
          manageAccountExplaination: "To edit or amend your personal contact details and manage your account please visit your account settings",
          managerDetails: "Manager Details",
          membershipHasBeenCancelled: "YOUR MEMBERSHIP HAS BEEN CANCELLED",
          minimumSize: "Minimum Size",
          toggleColorPicker: "Toggle Color Picker",
          appBackground: "App Background",
          mainText: "Main Text",
          supportEmail: "Support Email",
          accent: "Accent",
          hover: "Hover",
          missing: "Missing",
          accentButtonText: "Accent button text",
          errorSlashWarning: "Error/Warning",
          errorSlashWarningButtonText: "Error/Warning button text",
          moreAboutYou: "More About You",
          moreArticles: "More articles",
          myAccount: "My account",
          myProfile: `My ${settings?.global_wording?.misc_profile}`,
          name: "Name",
          nameInputRequiredError: "The name field is required",
          nameOfForm: "The name of the form",
          nationality: "Nationality",
          newArticle: "New Article",
          newChannel: `New ${settings?.global_wording?.misc_channel}`,
          newImage: `New ${settings?.global_wording?.misc_picture}`,
          newPassword: "New Password",
          next: "Next",
          nextArticle: "Next Article",
          nextStep: "Next Step",
          no: "No",
          noChangesToShow: "No changes to show",
          noName: "No Name",
          noRecentActivity: "No recent activity",
          noUsersToShow: `No ${settings?.global_wording?.entity_members.toLowerCase()}s to show.`,
          number: "Number",
          of: "of",
          ok: "ok",
          Ok: "Ok",
          oneOrMoreErrors: "There were one or more issues",
          oneOrMoreSponsorsError: "At least one sponsor is required",
          openChatError: `Unable to open a new chat with ${settings?.global_wording?.entity_members.toLowerCase()}`,
          options: "Options",
          optionsFrom: "Options From",
          pandaDocError: "There was an error retrieving your contract. Please try again later.",
          password: "Password",
          passwordReset: "Password Reset",
          pending: "Pending",
          pendingRevisions: "Pending Revisions",
          pendingMessage: "Your account has been created but is currently pending approval. Please check back later. You will receive an email when your account is approved.",
          pendingMessageAuto: "When your account is approved, this page will automatically refresh.",
          photo: "Photo",
          preview: "Preview",
          processing: "Processing",
          profileOverviewBlockButton: "Block this account",
          profileOverviewLastUpdated: "Updated",
          profileOverviewTitle: `${settings?.global_wording?.misc_profile} Overview`,
          profileOverviewUnblockButton: "Unblock this account",
          publish: "Publish",
          publishArticle: "Publish Article",
          publishingOptions: "Publishing Options",
          unschedule: "Unschedule",
          publishLater: "Publish Later",
          publishNow: "Publish Now",
          publishThisArticle: "Publish this article",
          publishThisArticleNow: "Publish this article now",
          questions: "Questions",
          recentProfileHistory: "Recent Account History",
          recieved: "Recieved",
          recoveryLinkWillBeSent: "A recovery link will be sent to your email.",
          register: settings?.global_wording?.section_register,
          registration: settings?.global_wording?.section_registration,
          registrationProgressHeader: `${settings?.global_wording?.section_registration} Progress`,
          reject: "Reject",
          rejected: "Rejected",
          rejectedMessage: `Your account has been rejected. If you have any questions about this, please contact ${settings?.global_wording?.app_name}.`,
          remove: "Remove",
          member: `${settings?.global_wording?.entity_members}`,
          removeUser: `Remove ${settings?.global_wording?.entity_members}`,
          request: "Request",
          requestRecieved: "Request Received",
          requested: "Requested",
          requires: "requires",
          requiresVerification: "Requires verification",
          resetPassword: "Reset Password",
          restore: "Restore",
          resultsOf: "results of",
          review: "Review",
          rules: "Rules",
          save: "Save",
          saveAsDraft: "Save as draft",
          saveChanges: "Save Changes",
          scheduledForPublishing: "Scheduled for publishing",
          scope: "Scope",
          search: "Search",
          see: "See",
          seeAll: "See all",
          selectAnItem: "Select an item",
          sendRecoveryLink: "Send recovery link",
          shareThis: "Share This",
          showing: "Showing",
          signIn: "Sign in",
          signInAs: "Sign in as a",
          signInAsUser: `Sign In as a ${settings?.global_wording?.entity_members.toLowerCase()}`,
          signOut: "Sign Out",
          signOutConfirm: "Are you sure you want to sign out?",
          signUp: "Sign Up",
          signedOut: "Signed Out",
          signedOutSuccess: "You've been successfully signed out",
          sponsorDetails: "Sponsor Details",
          stage: "Stage",
          stageRequiresReview: "Stage requires review",
          status: "Status",
          step: "Step",
          sureYouWantToUnpublishArticle: "Are you sure you want to unpublish this article?",
          telephoneNumber: "Telephone Number",
          thereWasUnknownError: "There was an unknown error",
          time: "Time",
          title: "Title",
          truncate: "Truncate",
          truncateArticlesModalHeading: "Truncate Articles?",
          truncateArticlesModalText: "Are you sure you want to permanently delete all articles?",
          type: "Type",
          typingSingular: "is typing",
          typingPlural: "are typing",
          unpublish: "Unpublish",
          update: "Update",
          updateFormError: "Unable to update form. Please try again later.",
          uploadFile: "Upload File",
          uploadImage: "Upload Image",
          uploadingFiles: "Uploading files",
          url: "URL",
          useExistingAddress: "Use existing address?",
          userNotesAddText: "Add a new note",
          userNotesDeleteError: "There was an error deleting your note.",
          userNotesDeleteSuccess: "Note deleted!",
          userNotesHeading: "notes",
          userNotesInputPlaceholder: "Type note here",
          userNotesNewError: "There was an error adding your note.",
          userNotesNewRequiredError: "Note required",
          userNotesNewSuccess: "New note added!",
          sponsorsName: "Sponsor's Name",
          userNotesNoNotesText: `This ${settings?.global_wording?.entity_members.toLowerCase()} doesn't have any notes yet.`,
          userNotesText: `These notes will only be visible to ${settings?.global_wording?.misc_admins.toLowerCase()}`,
          userNotesUpdateError: "There was an error updating your note.",
          userNotesUpdateSuccess: "Note updated!",
          userRevisionsHeading: "Pending Change Requests",
          userRevisionsInputPlaceholder: "Type a message",
          mainSectionNames: "Main Section Names",
          entityNames: "Entity Names",
          userRevisionsNewError: "Reason required",
          userRevisionsNoRevisionsText: `No ${settings?.global_wording?.entity_members.toLowerCase()} revisions.`,
          userRevisionsPendingExplaination: "Explanation of how the revision approval process works to better inform the athletes",
          userRevisionsRejectText2: "Reason for Rejecting",
          userRevisionsRejectText: "Add reason for rejecting",
          userSearchError: `We couldn't find any ${settings?.global_wording?.entity_members}s which matched your search criteria.`,
          users: `${settings?.global_wording?.entity_members}s`,
          visibility: "Visibility",
          instanceChat: `${settings?.global_wording?.app_name} Chat`,
          success: "Success",
          sponsorsWebsite: "Sponsor's Website",
          appName: "App Name",
          disabledSlashPrompt: "Disabled/Prompt",
          disabledSlashPromptButtonText: "Disabled/Prompt button text",
          breadcumbBar: "Breadcumb Bar",
          headerLogo: "Header Logo",
          loadingScreenImage: "Loading Screen Image",
          header: "Header",
          color: "Colour",
          headerAccent: "Header Accent",
          navigationAccent: "Navigation Accent",
          navigationAccentText: "Navigation Accent Text",
          modalText: "Modals/side panels text",
          chatMessagesIn: "Chat Messages In",
          chatMessagesOut: "Chat Messages Out",
          chatText: "Chat Text",
          profileNotifications: `${settings?.global_wording?.misc_profile} Notifications`,
          profileNotificationsText: `${settings?.global_wording?.misc_profile} Notifications Text`,
          headerText: "Header Text",
          noUsersFound: `No ${settings?.global_wording?.entity_members.toLowerCase()}s found.`,
          successButtonText: "Success button text",
          websiteUrlInputError: "Please enter a valid URL like https://www.wearesweet.co.uk",
          willBeScheduledToPublishOn: "This will be scheduled to be published on",
          yes: "Yes",
          yourDetails: "Your Details",
          yesterday: "Yesterday",
          today: "Today",
          uploadYourImage: "Upload your image",
          pleaseUploadYourImage: "Please upload your image",
          text: "Text",
          miscellaneous: "Miscellaneous",
          mobileModalsAndSidePanels: "Mobile modals and side panels",
          loginPagesBackground: "Login Pages background",
          loginLogoPanelBackground: "Login Logo Panel background",
          emailsSettingsTabExplainer1: "The following terminology will be changed for all emails.",
          emailsSettingsTabExplainer2: "These fields cannot be left blank.",
          globalWordingSettingsTabExplainer: "The following terminology will be changed throughout.",
          default: "Default",
          yourTerms: "Your Terms",
          newsTruncateFunctionality: "News Truncate Functionality",
          newsTruncateFunctionalityToggleExplainer: "Show 'Truncate' button on the news index screen",
          googleAnalyticsTrackingId: "Google Analytics Tracking ID",
          googleAnalyticsTrackingIdExplainer: "Page views and basic analytics will be enabled when a tracking ID is provided",
          showTheLoadingScreenFor: "Show the loading screen for",
          seconds: "Seconds",
          settings: "Settings",
          voiceMessage: "Voice Message",
          noTitle: "No title",
          noMembers: `No ${settings?.global_wording?.entity_members}s`,
          noArticles: "No articles have been published yet. Please check back another time.",
          supportRequest: "Support Request",
          supportRequestReceived: `Support`,
          supportRequestDescription: "We created this chat with the person who can help you with your query.",
          theUser: `The ${settings?.global_wording.entity_members}`,
          changeRequestedUserConfirmation: "Your change request has been received.",
          changeMadeUserConfirmation: "You profile has been updated.",
          profileCreated: `${settings?.global_wording.entity_members} Created`,
          memberRevisionsNoRevisionsText: `There are no pending requests for this ${settings?.global_wording.entity_members}`,
          memberNotesText: `Notes added here are available to admin users only, and not visible to the ${settings?.global_wording.entity_members}`,
          memberNotesAddText: "Add",
          lastUpdated: "Last updated",
          memberNotesInputPlaceholder: `Enter your note here...`,
          memberNotesNoNotesText: `No notes have been added yet...`,
          memberNotesNewSuccess: "The note has been saved.",
          memberNotesUpdateSuccess: "The note has been saved.",
          memberNotesDeleteSuccess: "The note has been deleted.",
          deleteConfirmationHeader: "Are you sure?",
          deleteConfirmationMessage: "Are you sure you want to delete this?",
          changeCompleted: "Change completed",
          pinnedChannel: `Pinned ${settings?.global_wording?.misc_channel}`,
          officialChannel: `Official ${settings?.global_wording?.misc_channel}`,
          channelSettings: `${settings?.global_wording?.misc_channel} settings`,
          leaveChannel: `Leave ${settings?.global_wording?.misc_channel}`,
          leaveChannelConfirmation: "To re-join, you will need to be invited back.",
          reportMessage: "Report message",
          suspicious: "Suspicious",
          harassing: "Harasssing",
          inappropriate: "Inappropriate",
          spam: "Spam",
          $appName: settings?.global_wording.app_name,
          reportIntro:
            "Reporting this message will flag it for review with " +
            settings?.global_wording.app_name +
            `. You may also choose to block this ${settings?.global_wording.entity_members.toLowerCase()} from contacting you.`,
          whyReporting: "Choose a reason for your report from the category below.",
          areYouSure: "Are you sure?",
          reportConfirm: "Reporting this message will flag it for review with " + settings?.global_wording.app_name + ".",
          report: "Report",
          reportAndBlock: "Report & Block",
          reportSent: "Report sent",
          reportSentMessage: "Your report has been sent to " + settings?.global_wording.app_name + " for review.",
          reportSentAndBlockedMessage:
            `Your report has been sent to ` +
            settings?.global_wording.app_name +
            ` for review and the ${settings?.global_wording.entity_members.toLowerCase()} has been blocked. They will not be able to contact you, but you will still be able to see their messages and you may still be in group ${settings?.global_wording?.misc_channel}s together.`,
          deleteDataExplainer:
            "You can delete all of your data from " +
            settings?.global_wording.app_name +
            " by clicking the button below. This will delete all of your data from the app and log you out. This action is irreversible, so please proceed with caution.",
          operatedBy: "This app is operated by",
          operatedBy2: "For any questions or concerns, please contact " + config.contact.email,
          deleteData: "Delete data",
          deleteMyData: "Delete My Data",
          deleteDataConfirm: "This action is irreversible. All of your data will be deleted and you will not be able to log in. Are you sure you want to delete your data?",
          help: "Help",
          changeEmail: "Change Email",
          change: "Change",
          changePasswordNote:
            settings?.global_wording.app_name +
            " is powered by Belong, a community engagement platform. If you are a member of any other organisations that also use Belong using the same email address as you are using on this app, your password will be changed on those apps too.",
          changeEmailNote:
            settings?.global_wording.app_name +
            " is powered by Belong, a community engagement platform. If you are a member of any other organisations that also use Belong using the same email address as you are using on this app, your email address will be changed on those apps too.",
          current: "Current",
          new: "New",
          verify: "Verify",
          enterPassword: "Enter password",
          reenterPassword: "Re-enter password",
          passwordRequirements: "Your password must contain at least 6 characters and include: at least one uppercase, at least one lowercase and at least one number.",
          passwordChanged: "Password Changed",
          passwordChangedSuccess: "Your password has been changed.",
          changeEmailPasswordExplainer: "For security, please enter your current password here so we know it's you.",
          newEmail: "New email address",
          emailChanged: "Email changed",
          emailChangedSuccess: "Your email address has been updated.",
          events: "Events",
          resources: "Resources",
          attachments: "Attachments",
          emptyFolder: "Looks like nothing has been uploaded to this folder yet. Check back another time.",
          files: "Files",
          all: "All",
          attending: "Attending",
          fromName: "From Name",
          helpdesk: "Helpdesk",
          noMembersMatchedYourSearch: `No ${settings?.global_wording.entity_members}s matched your query.`,
          selectAll: "Select all",
          unselectAll: "Unselect all",
          calendar: settings?.global_wording.section_calendar,
          drive: settings?.global_wording.section_drive,
          allDay: "All-day",
          myFiles: "My files",
          blockMember: `Block this ${settings?.global_wording.entity_members}`,
          subject: "Subject",
          message: "Message",
          sendToChat: "Send to chat",
          blockMembers: `Block ${settings?.global_wording.entity_members}(s)`,
          areYouSureYouWantToBlock: `Are you sure? They will not be able to send you messages`,
          checkYourEmail: "Check your email",
          addPhoto: "Add photo",
          cropPhoto: "Crop photo",
          changePhoto: "Change photo",
          confirmBan: `Are you sure you want to ban this ${settings?.global_wording.entity_members}?`,
          confirmRemove: `Are you sure you want to remove this ${settings?.global_wording.entity_members} from the ${settings?.global_wording?.misc_channel}?`,
          memberBanned: `The ${settings?.global_wording.entity_members} has been banned.`,
          memberRemoved: `The ${settings?.global_wording.entity_members} has been removed from this ${settings?.global_wording?.misc_channel}.`,
          adminViewOptions: "Admin View Options",
          adminViewOptionsExplainer: `These options are available to you as an admin user. Use these options to override your personal tags and view all items in the ${settings?.global_wording.section_calendar} or ${settings?.global_wording.section_drive}`,
          showAllCalendarEvents: "Show all Events",
          showAllFiles: "Show all Files",
          signInDetails: "Sign-in details",
          noFiles: "No files have been uploaded yet. Files are uploaded by your organisation. You'll get a notification when new files are added.",
          noContactCategories: `The Helpdesk has not yet been configured. For any questions or concerns, please contact ${settings?.global_wording.app_name} at ${config.contact.email}.`,
          misc: "Misc",
          allChats: `All ${settings?.global_wording.section_chat.toString().toLowerCase()}s`,
          helpdeskOnly: "Helpdesk only",
          addMembers: `Add ${settings?.global_wording.entity_members}s`,
          membersAdded: `The selected ${settings?.global_wording.entity_members}(s) have been added to the ${settings.global_wording.section_chat.toString().toLowerCase()}`,
          errorAddingMembers: `There was an error adding the selected ${settings?.global_wording.entity_members}(s) to the ${settings.global_wording.section_chat.toString().toLowerCase()}`,
          submitting: "Submitting...",
          submit: "Submit",
          registrationSuccessLoggedIn: `Your ${settings?.global_wording.section_registration.toString().toLowerCase()} has been successful and you are now logged in.`,
          registrationSuccessLoginRequired: `Your ${settings?.global_wording.section_registration.toString().toLowerCase()} has been successful. Please log in to continue.`,
          profileUpdated: "Your profile has been updated.",
          errorUpdatingProfile: "There was an error updating your profile. Please try again later.",
          notInAnyChatsYet: `You are not in any ${settings?.global_wording.section_chat.toString().toLowerCase()}s yet.`,
          whyNotCreateYourOwn: "Why not create your own?",
          noConversationsMatchedYourFilter: "No conversations matched your filter",
          noHelpdeskConversations: "No helpdesk conversations yet",
          selectThisOptionToRegisterAsA: "Select this option to register as a",
          selectMemberType: `Select the ${settings.global_wording.entity_members.toString().toLowerCase()} type that you wish to register as from the list below.`,
          youAreRegisteringAsA: "You are registering as a",
          error: "Error",
        },
      },
    },
  });

  i18next.services.formatter?.add("capitalize", (value, lng, options) => {
    return value.charAt(0).toUpperCase() + value.slice(1);
  });
};

export default initializeI18next;
